"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Modal = require("@insided/shared/uikit/Modal");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var TrashModal = function TrashModal(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      isOpen = _ref.isOpen,
      onTrash = _ref.onTrash,
      _onClose = _ref.onClose;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: isOpen,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: (0, _preact.h)(_phrase.default, {
      p: title
    }),
    onClose: function onClose() {
      return _onClose();
    }
  }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("div", {
    className: "trash-modal"
  }, (0, _preact.h)(_phrase.default, {
    p: subTitle
  }))), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
    title: (0, _preact.h)(_phrase.default, {
      p: "frontend_moderation.trash"
    }),
    onClick: onTrash,
    size: "medium",
    variant: "warning",
    className: "qa-confirm-trash",
    "data-track-type": "click",
    "data-element-name": "Trash button"
  }), (0, _preact.h)(_Button.default, {
    title: (0, _preact.h)(_phrase.default, {
      p: "frontend_moderation.cancel"
    }),
    onClick: _onClose,
    size: "medium",
    "data-track-type": "click",
    "data-element-name": "Cancel trash button"
  })));
};

var _default = TrashModal;
exports.default = _default;